import { orderStage } from 'common/constants/booking';

export const canUpdateBookingStatus = (currentStage, canUpdate) => {
  if (!canUpdate) {
    return false;
  }
  if (![orderStage.IN_PROGRESS, orderStage.COMPLETED].includes(currentStage)) {
    return false;
  }
  return true;
};
